// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getIsEqual = (x?: any, y?: any): boolean => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  return x && y && typeof x === 'object' && typeof y === 'object'
    ? Object.keys(x).length === Object.keys(y).length &&
        Object.keys(x).reduce(function (isEqual, key) {
          return isEqual && getIsEqual(x[key], y[key]);
        }, true)
    : x === y;
};
